import cssVars from 'css-vars-ponyfill'
// import Navigation from './navigation'
// import Global from './global'
// import GMap from './gmap'

export default {
  init() {
    // Navigation.init()
    this.setCSSVars()

    // GMap.init()
    this.onResize()
    // setTimeout(() => {
    //   this.resizeVideo()
    // }, 100)

    $(
      'a[href^="#"]:not([href="#"],[href^="#fancy-"],[href^="#collapse-"],[href^="#pane-"],[href^="#tabs-"],[role="tab"],[data-vc-accordion])'
    ).on('click', e => {
      this.smoothScroll($(e.currentTarget).attr('href'), e)
    })
    if (window.location.hash && $(window.location.hash).length) {
      this.smoothScroll(window.location.hash)
    }
  },
  onLoad() {},
  setCSSVars() {
    cssVars({
      variables: {
        '--body-width': document.body.clientWidth + 'px',
      },
    })
  },
  smoothScroll(link, e) {
    if (
      link &&
      link.indexOf('#') > 0 &&
      link.split('#')[0].indexOf(location.origin + location.pathname) !== 0
    ) {
      return false
    }
    if (e) e.preventDefault()
    let hash = false
    if (!link && window.location.hash) {
      hash = window.location.hash
    } else if (link && link.indexOf('#') >= 0) {
      hash = '#' + link.split('#')[1]
    } else if (
      link &&
      location.pathname.replace(/^\//, '') ==
        link.pathname.replace(/^\//, '') &&
      location.hostname == link.hostname
    ) {
      hash = link.hash
    }
    if (hash && $(hash).length) {
      // if (Global.htmlFixedState) {
      //   Navigation.menuToggle()
      // }
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        600
      )
      history.replaceState(null, null, hash)
    }
    $(window).trigger('hashchange')
  },
  // resizeVideo() {
  //   const $holder = $('.js-video-wrapper')
  //   $holder.each(function () {
  //     const $videoWrapper = $(this)
  //     const width = 16
  //     const height = 9
  //     $videoWrapper.find('.videoHolder').each(function () {
  //       const $videoHolder = $(this)
  //       if (
  //         $videoWrapper.outerWidth() / width >
  //         $videoWrapper.outerHeight() / height
  //       ) {
  //         $videoHolder.css({
  //           width: '100%',
  //           height: 'auto',
  //         })
  //       } else {
  //         $videoHolder.css({
  //           width: ($videoWrapper.outerHeight() * width) / height,
  //           height: '100%',
  //         })
  //       }
  //     })
  //   })
  // },
  onResize() {
    $(window).resize(() => {
      this.setCSSVars()
      // setTimeout(() => {
      //   this.resizeVideo()
      // }, 100)
    })
  },
}
